import React from "react"
import { Row as AntdRow } from "antd"
import type { RowProps } from "antd/lib/row"

export const Row = ({ children, ...props }: RowProps): JSX.Element => {
  return <AntdRow {...props}>{children}</AntdRow>
}
